module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("66BQJ"))).then(() => parcelRequire('d0iPb'));